import { createAction } from 'redux-act';

export const setObligationModalVisible = createAction<boolean>('SET_OBLIGATION_MODAL_VISIBLE');
export const setObligationForm = createAction<Record<string, unknown>>('SET_OBLIGATION_FORM');
export const closeObligationForm = createAction('CLOSE_OBLIGATION_FORM');
